import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import audiences from './audiences.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import commercialGoals from './commercialGoals.json';
import campaignCreate from './campaignCreate.json';
import campaignReport from './campaignReport.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import products from './products.json';
import dataTransfer from './dataTransfer.json';
import deals from './deals.json';
import formBuilder from './formBuilder.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contentTemplates from './contentTemplates.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import support from './support.json';
import tasks from './tasks.json';
import teamsSettings from './teamsSettings.json';
import timeline from './timeline.json';
import webhooks from './webhooks.json';
import whatsappSends from './whatsappSends.json';
import whatsappTemplates from './whatsappTemplates.json';
import yearInReview from './yearInReview.json';
import sourceAttributes from './sourceAttributes.json';
import customAttributeValueValidation from './customAttributeValueValidation.json';
import dashboard from './dashboard.json';
import commercialWidgets from './commercialWidgets.json';
import commercialWidgetsDialog from './commercialWidgetsDialog.json';

export default {
  ...sourceAttributes,
  ...customAttributeValueValidation,
  ...dashboard,
  ...commercialWidgets,
  ...commercialWidgetsDialog,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...audiences,
  ...bulkActions,
  ...campaign,
  ...commercialGoals,
  ...campaignCreate,
  ...campaignReport,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...products,
  ...dataTransfer,
  ...deals,
  ...formBuilder,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...mfa,
  ...onboarding,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...support,
  ...tasks,
  ...teamsSettings,
  ...timeline,
  ...webhooks,
  ...whatsappSends,
  ...whatsappTemplates,
  ...yearInReview,
};
